import { Button } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { getButtonSx, mergeSx } from "./buttonStyles";

export const ButtonSecondary = ({
  size = "sm",
  sx,
  sxButton,
  iconOnly,
  tooltip,
  ...props
}: IButtons) => (
  <Button
    {...props}
    sx={mergeSx((theme) => getButtonSx(theme, "secondary", size), sx, sxButton)}
  />
);
